import { render, staticRenderFns } from "./ModalSetArgs.vue?vue&type=template&id=1f1a3afa&scoped=true"
import script from "./ModalSetArgs.vue?vue&type=script&lang=js"
export * from "./ModalSetArgs.vue?vue&type=script&lang=js"
import style0 from "./ModalSetArgs.vue?vue&type=style&index=0&id=1f1a3afa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f1a3afa",
  null
  
)

export default component.exports